import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./ContentSharingIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const AssetsList = Loadable({
  loader: () => import('./containers/ContentSharingAssetsPage'),
  loading: () => <Loading withContentWrapper />,
});

export const RequestsList = Loadable({
  loader: () => import('./containers/ContentSharingRequestsPage'),
  loading: () => <Loading withContentWrapper />,
});
